import { useAuthStore } from '@/stores/auth';
import { useScopeStore } from '@/stores/scope';

let epoch = 0;
useAuthStore.subscribe((next, previous) => {
  if (next.user?.id !== previous.user?.id || next.currentClub?.id !== previous.currentClub?.id || next.hydrating !== previous.hydrating || next.me?.host_kind !== previous.me?.host_kind || next.isClubAdmin !== previous.isClubAdmin || next.isSuperAdmin !== previous.isSuperAdmin || JSON.stringify(next.me?.active_scope?.capabilities) !== JSON.stringify(previous.me?.active_scope?.capabilities) || (!next.me && previous.me)) epoch++;
});
useScopeStore.subscribe((next, previous) => {
  if (next.teamId !== previous.teamId || next.seasonId !== previous.seasonId) epoch++;
});
export function boundaryProof() {
  const auth = useAuthStore.getState();
  const scope = useScopeStore.getState();
  return JSON.stringify([epoch, auth.user?.id, auth.currentClub?.id, scope.teamId, scope.seasonId, window.location.host]);
}
export const isCurrentBoundary = (proof: string) => boundaryProof() === proof;
export function usdEstimate(value: number) { return `$${(value / 1e9).toFixed(2)} USD estimate`; }
export function operatorCeiling(value: string): number | null {
  if (!value.trim()) return null;
  const amount = Number(value);
  const nano = amount * 1e9;
  return Number.isFinite(amount) && amount >= 0 && amount <= 50 && Number.isSafeInteger(nano) ? nano : null;
}
export async function guarded<T>(proof: string, work: Promise<T>): Promise<T> {
  const result = await work;
  if (!isCurrentBoundary(proof)) throw new Error('Assist context changed; response discarded.');
  return result;
}
